// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1g9hD","disabled":"FileBtn_disabled__2U7ql","warn":"FileBtn_warn__1X8Le","fade":"FileBtn_fade__2A60l"};